import { IBrand } from 'data/schema';

export function injectShowroom({ onLoad = () => {} }: { onLoad: (result: boolean) => void }) {
  const scriptId = 'avp-3dws-deck-script';
  const existingScript = document.getElementById(scriptId);

  if (!existingScript && import.meta.env.MODE !== 'test') {
    const script = document.createElement('script');
    script.type = 'module';
    script.src = 'https://avp-3dws-deck.eu-west-1-web-streaming.avp.tech/avp-3dws-deck.js';
    script.id = scriptId;
    script.onload = () => onLoad(true);
    document.head.appendChild(script);
  } else {
    onLoad(true);
  }
}

export function getShowroomConfig(brand: IBrand, isScheduledSession = false): string {
  const showroomConfigs: Record<IBrand, string> = {
    A: isScheduledSession ? 'a-3DExhibition-scheduler-2025' : 'a-3DExhibition-default-2025',
    V: 'v-3DExhibition-default-2025',
    S: 'c-3DExhibition-default-2025',
    C: 'c-3DExhibition-default-2025',
    E: 'bentley-default',
    L: 'l-3DExhibition-default-2025',
    M: 'ngc-default',
    N: 'n-3DExhibition-default-2025',
    P: 'ngc-default',
    '*': 'a-3DExhibition-default-2025',
  };

  return showroomConfigs[brand] || showroomConfigs['*'];
}
